import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/* const pDialogKey for ConfirmDialogComponent */
export const CONFIRM_PDIALOG_KEY = 'confirmationDialogKey';

@Component( {
    selector: 'his-confirm-dialog',
    templateUrl: './his-confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisConfirmDialogComponent {
    @Input() width = 450;

    /**
     * Key of the confirm dialog; default = CONFIRM_PDIALOG_KEY
     */
    @Input() pDialogKey = CONFIRM_PDIALOG_KEY; // key of <p-confirmDialog>
}
